<template>
  <!-- 短信自助充值组件 -->
  <div>
    <!-- <el-dialog :visible.sync="isShow" width="900px" :show-close="false" top="4vh" :close-on-click-modal="false"> -->
    <x-popup :isShow="isShow" width="500px" @cencal="fCancalPopupShow">
      <!-- -->
      <div slot='head' class="c-80 u-flex-1">
        <span class="x-p-r-10">短信自助充值</span>当前短信剩余：<span class="c-smRed">{{smsTotal}}</span> 条
      </div>
      <div v-if="type=='sms'">
        <div class="x-flex x-flex-wrap  x-row-between"
          style="overflow-y: auto;max-height: 330px;-moz-user-select: none;-webkit-user-select: none;">
          <div class="x-w140 x-bd x-m-t-10 x-m-b-10 x-text-c x-cur-poi  x-bd-ra-4" v-for="item in smsList"
            :key="item.label" @click="fActiveSms(item)" :class="active == item.label?'active':''">
            <div class='x-p-b-5 x-p-t-5'>{{item.label}}</div>
            <div class='x-p-b-5 x-p-t-5 x-font-16'>￥{{item.fee}}</div>
          </div>
          <div class="x-w140">

          </div>
        </div>
        <div class="x-text-r x-p-t-20 x-p-b-10">
          <x-button @click.native='fRecharge'>确认充值</x-button>
        </div>
      </div>
      <div v-else>
        <div class="x-text-c">
          <div class='x-p-t-20 x-font-20'>{{params.sucess_msg}}</div>
          <div class='x-p-t-10 f600 x-font-20' style="color: #FF5E44;">{{params.sucess_num}}</div>
          <!-- <div class='x-p-t-10 x-flex x-row-center'>
            <div class="x-w200 x-h200 x-bd x-bd-ra x-flex x-row-center">
              <div id="qrcodeMax" ref="qrCodeUrlMax"></div>
            </div>
          </div> -->
          <div class='x-p-t-20 c-80'>感谢您的支持，有任何问题可以联系我们</div>
          <div class='x-p-t-10 c-80 x-p-b-50'>你的满意，一直是我们不懈的追求！</div>
          <div class='x-p-t-10 x-p-b-30'>
            <x-button @click.native='fCancalPopupShow'>关闭</x-button>
          </div>
        </div>
      </div>
    </x-popup>
    <smRecharge :isShow="payQrPop" :params='params' @cencal='fCancalPay' type='smSellSmsCz'></smRecharge>
  </div>
</template>

<script>
  import smRecharge from './smRecharge.vue'
  export default {
    components: {
      smRecharge
    },
    props: {
      // 是否显示
      isShow: {
        type: [String, Boolean],
        default: false,
      },
    },
    data() {
      return {
        smsTotal: '-',
        type: 'sms',
        active: '', //选中方案
        mallInfo: [],
        payQrPop: false,
        params: {},
        smsInfo: {},
        smsList: []
      }
    },
    watch: {
      // async mallProId(newVal) {
      //   this.init()
      // },
      async isShow(newVal) {
        if (newVal) {
          this.type = 'sms'
          this.active = ''
          this.fGetSmsTotal()
          let resInfo = await this.fGetShopPro()
          if (resInfo.result != 'sucess') {
            return this.$message(resInfo.msg)
          }
          this.smsList = JSON.parse(resInfo.data.pro_price)
        }
      }
    },
    methods: {
      // async init(newVal) {
      //   let res = await this.api.smCommon.fGetProInfo({
      //     oper: 'MALL_PRO_ID',
      //     clsId: '00',
      //     // mallId:'0001',
      //     searchStr: newVal || this.mallProId,
      //     pageSize: 20,
      //     nowPage: 1,
      //     zcYn: false,
      //     mhYn: true,
      //   })
      //   if (res.result != 'sucess') {
      //     return this.$message(res.msg)
      //   }

      // },
      async fGetSmsTotal() {
        let res = await this.fGetSmsSendMaster()
        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }

        this.smsTotal = res.data[0].now_count

      },
      //选中短信
      fActiveSms(item) {
        this.active = item.label
        this.smsInfo = item
      },
      //充值弹窗
      fRecharge() {
        if (this.api.smCom.fSmIsEmpty(this.smsInfo)) {
          return this.$message('请选择短信充值方案')
        }
        this.payQrPop = true
        this.params = {
          msg: this.smsInfo.value + '条短信',
          money: this.smsInfo.fee,
          num: this.smsInfo.value,
        }
      },
      //关闭弹窗
      fCancalPopupShow() {
        this.smsInfo = {}
        this.params = {}
        this.$emit("cencal");
      },
      fCancalPay(e) {
        if (!this.api.smCom.fSmIsEmpty(e)) {
          this.type = 'paySucess'
        }
        this.payQrPop = false
        this.fGetSmsTotal()
        Object.assign(this.params, e)
      },
      //请求开始==================================
      // 获取短信剩余数量 GET_SMS_SEND_MASTER    SMS_ID

      async fGetShopPro(obj) {
        let js = {};
        js['OPER'] = 'PRO_ID'
        js['SHOP_ID'] = 'smCloud'
        js['PRO_ID'] = 'dxcz'
        let res = await this.api.smSellApi.fPostToSmSellMainSrvApi('GET_SHOP_PRO', js, )
        return res
      },
      async fGetSmsSendMaster() {
        let js = {};
        js['SMS_ID'] = "sys";
        let res = await this.api.smSellApi.fPostToSmSellQueryApi("GET_SMS_SEND_MASTER", js)
        return res;
      },
      // 请求结束================================
    }
  }
</script>

<style lang="less" scoped="scoped">
  /deep/.el-input__icon {
    line-height: unset;
  }

  .active {
    color: #6396FC;
    border-color: #6396FC;
  }
</style>



// WEBPACK FOOTER //
// src/components/smsRecharge.vue